export default __webpack_public_path__ + "static/media/sample1.85cc9925.jpeg";